module.exports = __webpack_public_path__ + "img/10秒で分かる相続税.f4969c04.png";